import { Label } from "../../../../../components/Label";
import styles from "../QuoteForm.module.scss";

interface QuoteClientSectionProps {
  clients: ClientProfile[];
  selectedClientId: string;
  onSelectClient: (clientId: string) => void;
  clientName: string;
  onClientNameChange: (name: string) => void;
  taxId: string;
  onTaxIdChange: (taxId: string) => void;
  cityAddress: string;
  onCityAddressChange: (address: string) => void;
  phone: string;
  onPhoneChange: (phone: string) => void;
  clientEmail: string;
  onClientEmailChange: (email: string) => void;
  advisorEmail: string;
}

export function QuoteClientSection({
  clients,
  selectedClientId,
  onSelectClient,
  clientName,
  onClientNameChange,
  taxId,
  onTaxIdChange,
  cityAddress,
  onCityAddressChange,
  phone,
  onPhoneChange,
  clientEmail,
  onClientEmailChange,
  advisorEmail,
}: QuoteClientSectionProps) {
  return (
    <>
      {/* Client */}
      <div className={styles.formGroup}>
        <Label htmlFor="clienteSeleccion" className={styles.label}>
          Seleccionar Cliente
        </Label>
        <select
          id="clienteSeleccion"
          value={selectedClientId}
          onChange={(e) => onSelectClient(e.target.value)}
          className={styles.input}
        >
          <option value="new-client">Nuevo cliente</option>
          {clients.map((client) => {
            const fullName =
              `${(client.first_name || "").trim()} ${(
                client.last_name || ""
              ).trim()}`.trim() || "Sin nombre";
            const city = (client.city_name || "").trim();
            const street = (client.street_address || "").trim();
            const neighborhood = (client.neighborhood || "").trim();
            const location = [city, street, neighborhood]
              .filter(Boolean)
              .join(" - ");

            return (
              <option key={client.id} value={String(client.id)}>
                {location ? `${fullName} (${location})` : fullName}
              </option>
            );
          })}
        </select>
      </div>

      <div className={styles.formGroup}>
        <Label htmlFor="cliente" className={styles.label}>
          Cliente
        </Label>
        <input
          type="text"
          id="cliente"
          value={clientName}
          onChange={(e) => onClientNameChange(e.target.value)}
          className={styles.input}
          placeholder="Nombre del cliente"
        />
      </div>

      {/* NIT/ID */}
      <div className={styles.formGroup}>
        <Label htmlFor="nit" className={styles.label}>
          NIT/ID
        </Label>
        <input
          type="text"
          id="nit"
          value={taxId}
          onChange={(e) => onTaxIdChange(e.target.value)}
          className={styles.input}
          placeholder="000000000-0"
        />
      </div>

      {/* City and Address */}
      <div className={styles.formGroup}>
        <Label htmlFor="ciudadDireccion" className={styles.label}>
          Ciudad y Dirección
        </Label>
        <input
          type="text"
          id="ciudadDireccion"
          value={cityAddress}
          onChange={(e) => onCityAddressChange(e.target.value)}
          className={styles.input}
          placeholder="Ciudad - Dirección completa"
        />
      </div>

      {/* Phone */}
      <div className={styles.formGroup}>
        <Label htmlFor="telefono" className={styles.label}>
          Teléfono
        </Label>
        <input
          type="tel"
          id="telefono"
          value={phone}
          onChange={(e) => onPhoneChange(e.target.value)}
          className={styles.input}
          placeholder="300 123 4567"
        />
      </div>

      {/* Client Email */}
      <div className={styles.formGroup}>
        <Label htmlFor="emailCliente" className={styles.label}>
          Email Cliente
        </Label>
        <input
          type="email"
          id="emailCliente"
          value={clientEmail}
          onChange={(e) => onClientEmailChange(e.target.value)}
          className={styles.input}
          placeholder="cliente@ejemplo.com"
        />
      </div>

      {/* Advisor Email */}
      <div className={styles.formGroup}>
        <Label htmlFor="correoAsesor" className={styles.label}>
          Correo Asesor
        </Label>
        <input
          type="email"
          id="correoAsesor"
          value={advisorEmail}
          className={styles.input}
          placeholder="asesor@latinstore.com"
          readOnly
          aria-readonly="true"
        />
      </div>
    </>
  );
}
